<template>
	<b-container fluid>
		<b-row align-h="center">
			<loader v-if="isLoading" />
			<b-col class="mt-5" cols="8" v-if="!isLoading && passwordSetSuccessfully && isTokenValid">
				<b-row align-h="center">
					<b-img fluid :src="require('../../../static/alldone-icon.svg')" />
				</b-row>

				<b-row align-h="center" class="text-center">
					<div>
						<h1 class="Reset__header">All done</h1>
						<p class="Reset__instruction">Nice one, you will now be redirected to the login page.</p>
					</div>
				</b-row>
			</b-col>

			<b-col class="mt-5" cols="8" v-if="!isLoading && !isTokenValid && !passwordSetSuccessfully">
				<b-row align-h="center">
					<b-img fluid :src="require('../../../static/invitation-icon.svg')" />
				</b-row>

				<b-row align-h="center" class="text-center">
					<div>
						<h1 class="Reset__header">Error</h1>
						<p class="Reset__instruction text-danger">
							This link has been expired or has already been used. <br />
							Please request to be invited once more.
						</p>
					</div>
				</b-row>
			</b-col>

			<b-col class="mt-5" cols="8" v-if="!isLoading && !passwordSetSuccessfully && isTokenValid">
				<b-row>
					<b-col cols="1" />
					<b-col cols="2">
						<b-img fluid :src="require('../../../static/invitation-icon.svg')" />
					</b-col>
					<b-col cols="6" class="text-left">
						<b-form novalidate name="PasswordForm">
							<h1 class="Reset__header">Welcome!</h1>
							<p class="Reset__instruction">
								One last step, you need to set a password for your account and you’ll be good to go.
							</p>
							<b-form-input
								class="mt-1 mb-2"
								tabIndex="1"
								name="email"
								:disabled="true"
								:type="'email'"
								v-model="formData.email"
								placeholder="Email"
							/>

							<div class="input-group">
								<b-form-input
									tabIndex="1"
									name="password"
									:type="inputType"
									:state="passwordStrengthScore == 4"
									v-model="formData.password"
									placeholder="Password"
								/>
								<div class="input-group-addon">
									<b-button
										tabIndex="4"
										type="button"
										class="btn-clean mt-1"
										:aria-label="'show password'"
										@click.prevent="togglePassword()"
									>
										<svg
											v-if="showPassword"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
										>
											<path
												d="M12 9c1.641 0 3 1.359 3 3s-1.359 3-3 3-3-1.359-3-3 1.359-3 3-3zM12 17.016c2.766 0 5.016-2.25 5.016-5.016s-2.25-5.016-5.016-5.016-5.016 2.25-5.016 5.016 2.25 5.016 5.016 5.016zM12 4.5c5.016 0 9.281 3.094 11.016 7.5-1.734 4.406-6 7.5-11.016 7.5s-9.281-3.094-11.016-7.5c1.734-4.406 6-7.5 11.016-7.5z"
											></path>
										</svg>
										<svg
											v-else
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
										>
											<title>Don't Show Password</title>
											<path
												d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"
											></path>
										</svg>
									</b-button>
								</div>
							</div>

							<b-form-input
								tabIndex="2"
								name="confirmPassword"
								class="mt-2 mb-2"
								:type="'password'"
								:state="
									formData.confirmPassword.length > 1 &&
										formData.password === formData.confirmPassword
								"
								v-model="formData.confirmPassword"
								placeholder="Confirm Password"
							/>

							<p
								class="Reset__confirm-password text-danger"
								v-if="formData.password !== formData.confirmPassword"
							>
								The passwords you have entered do not match
							</p>

							<check-password-strength v-model="formData.password" @score="updateScore" />

							<p v-if="passwordStrengthScore != 4 && formData.password" class="Reset__tip text-muted">
								Your password must be minumum 8 characters and must include at least 1 uppercase,
								lowercase, number and special character.
							</p>

							<b-button
								tabIndex="3"
								class="float-right"
								variant="primary"
								v-text="'Create'"
								type="submit"
								:disabled="!isPasswordFormValid || isLoading"
								@click="submit"
							/>
						</b-form>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script type="text/javascript">
import { mapActions } from 'vuex';
import Loader from '../../components/Loader';
import CheckPasswordStrength from '../../components/CheckPasswordStrength';

export default {
	layout: 'SecondaryLayout',
	components: {
		CheckPasswordStrength,
		Loader
	},
	data: () => ({
		isTokenValid: false,
		passwordMatch: false,
		isLoading: false,
		formData: {
			email: '',
			password: '',
			confirmPassword: ''
		},
		invitation: null,
		inputType: 'password',
		showPassword: false,
		passwordStrengthScore: null,
		passwordSetSuccessfully: null
	}),
	computed: {
		token() {
			return this.$route.params.token;
		},
		isPasswordFormValid() {
			return (
				this.formData.password &&
				this.formData.password === this.formData.confirmPassword &&
				this.passwordStrengthScore == 4
			);
		}
	},
	created() {
		if (this.token) {
			const token = this.token;
			this.isLoading = true;
			this.validateInvitationToken({ token });
		}
	},
	methods: {
		...mapActions({
			getInvitation: 'auth/getInvitation',
			acceptInvitation: 'auth/acceptInvitation'
		}),
		async validateInvitationToken({ token }) {
			let response = await this.getInvitation({ token });
			if (response.success && response.data && response.data.active) {
				this.formData.email = response.data.email;
				this.invitation = response.data;
				this.isTokenValid = true;
				this.isLoading = false;
			} else {
				this.isTokenValid = false;
				this.isLoading = false;
			}
		},
		async submit() {
			this.isLoading = true;
			this.invitation.confirm_password = this.formData.confirmPassword;
			this.invitation.password = this.formData.password;
			let response = await this.acceptInvitation({ invitation: this.invitation });
			if (response.success && response.data && response.data.token) {
				this.passwordSetSuccessfully = true;
				this.isLoading = false;
				//redirect to the URL on the invitation after 5 seconds
				setTimeout(() => {
					window.location.href = `${this.invitation.redirectUrl}`;
				}, 3000);
			} else {
				this.passwordSetSuccessfully = false;
				this.isLoading = false;
				this.isTokenValid = true;
			}
		},
		updateScore(score) {
			this.passwordStrengthScore = score;
		},
		togglePassword() {
			this.showPassword = !this.showPassword;
			if (this.showPassword) {
				this.inputType = 'text';
			} else {
				this.inputType = 'password';
			}
		}
	}
};
</script>

<style lang="scss">
.Reset__header {
	font-family: SourceSansPro;
	font-size: 35px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #42485a;
}

.Reset__instruction {
	width: 365px;
	height: 38px;
	font-family: SourceSansPro;
	font-size: 15px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #42485a;
}

.Reset__confirm-password {
	width: 365px;
	height: 16px;
	font-family: SourceSansPro;
	font-size: 13px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: 1.23;
	letter-spacing: normal;
	color: var(--OF_Red);
}

.Reset__tip {
	width: 365px;
	height: 32px;
	font-family: SourceSansPro;
	font-size: 13px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: 1.23;
	letter-spacing: normal;
	color: var(--OF_Grey_2);
}
</style>
